import apiClient from '../apiClient';
import { POST_RESTAURANT_ITEM_URL } from '../apiUrl';

const postRestaurantItemApi = data => {
  return apiClient.post(POST_RESTAURANT_ITEM_URL, data);
};

export default postRestaurantItemApi;
